import { useState, useEffect } from "react";

export function useOddsTrend(trend, value) {
  const isUp = trend === "up" || trend === "increased" || trend === 1 || trend === "1";
  const isDown = trend === "down" || trend === "decreased" || trend === 2 || trend === "2";
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    if (isUp || isDown) {
      setAnimating(false);
      const restartTimer = setTimeout(() => {
        setAnimating(true);
        const timer = setTimeout(() => setAnimating(false), 2000);
        return () => clearTimeout(timer);
      }, 50);
      return () => clearTimeout(restartTimer);
    }
  }, [trend, value]);

  const valueColorClass = isUp
    ? "text-[var(--theme-primary)]"
    : isDown
      ? "kbv-text-vibrant-red"
      : "text-[var(--theme-text)]";

  const successValueColorClass = isUp
    ? "text-[var(--theme-primary)]"
    : isDown
      ? "kbv-text-vibrant-red"
      : "kbv-text-main";

  const borderBgClass = isUp
    ? "kbv-border-success-light kbv-bg-success-light transition-colors duration-300"
    : isDown
      ? "kbv-border-red-light kbv-bg-red-light transition-colors duration-300"
      : "kbv-border-lighter bg-white transition-colors duration-300";

  const animationClass = animating 
    ? (isUp ? "animate-wager-up" : isDown ? "animate-wager-down" : "") 
    : "";

  return {
    isUp,
    isDown,
    animating,
    valueColorClass,
    successValueColorClass,
    borderBgClass,
    animationClass
  };
}
